import { UserRead } from '../models/Models';

export default class UserUtils {
  public static getFullName(user?: UserRead): string {
    return `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
  }
}
